import { Button, Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Form, FormControl, InputGroup, Modal } from "react-bootstrap";
import { useCustomer, useValidWarehouse } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import MarkShipped from "./MarkShipped";

function UpdateWarehouseAndMarkShipped({ isDisabled, buttonText, order }) {
  const [warehouse, setWarehouse] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState();
  const [trackingUrl, setTrackingUrl] = useState(order.tracking_url);
  const [trackingId, setTrackingId] = useState(order.tracking_id);
  const [currentWarehouse, setCurrentWarehouse] = useState();
  const [show, setShow] = useState(false);

  const { customerData, fetchCustomerData } = useCustomer();

  const { setToaster } = useToast();
  const {
    checkValidWarehouse,
    validWarehouseData,
    fetchCheckValidWareHouse,
    fetchValidWarehouse,
    updateWarehouse,
  } = useValidWarehouse();

  useEffect(() => {
    if(show){
      fetchCheckValidWareHouse(order.id);
      fetchValidWarehouse();
    }
  }, [order, show]);

  useEffect(() => {
    if (checkValidWarehouse.isValid && validWarehouseData.length) {
      setWarehouse(
        validWarehouseData.filter(
          (warehouse) => warehouse.code === checkValidWarehouse.name
        )[0]
      );
    }
  }, [checkValidWarehouse, validWarehouseData]);

  useEffect(() => {
    setCurrentWarehouse(checkValidWarehouse.isValid ? warehouse?.code : null);
    setSelectedWarehouse(checkValidWarehouse.isValid ? warehouse?.code : null);
  }, [checkValidWarehouse]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  return (
    <div>
      <Tooltip title="Update Warehouse & Mark Shipped">
        <div onClick={handleShow}>
          <span
            className={`mt-n1 bg-${
              isDisabled ? "secondary" : "primary"
            } text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
            id="update-warehouse"
          >
            {buttonText}
          </span>
        </div>
      </Tooltip>

      <Modal show={show} onHide={() => handleClose()} style={{ top: "15%" }}>
        <Modal.Header>Warehouse Info</Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1" style={{ width: "12rem" }}>
              Tracking URL
            </InputGroup.Text>
            <FormControl
              placeholder="Tracking URL"
              aria-label="Tracking URL"
              aria-describedby="basic-addon1"
              defaultValue={order.tracking_url}
              onChange={(event) => {
                setTrackingUrl(event.target.value);
              }}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1" style={{ width: "12rem" }}>
              Tracking ID
            </InputGroup.Text>
            <FormControl
              placeholder="Tracking ID"
              aria-label="Tracking ID"
              aria-describedby="basic-addon1"
              defaultValue={order.tracking_id}
              onChange={(event) => {
                setTrackingId(event.target.value);
              }}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1" style={{ width: "12rem" }}>
              Current Warehouse
            </InputGroup.Text>
            <FormControl
              placeholder="Current warehouse"
              aria-label="Current warehouse"
              aria-describedby="basic-addon1"
              value={checkValidWarehouse.isValid ? warehouse?.name : "none"}
              disabled
            />
          </InputGroup>
          <InputGroup className="mb-3 d-flex">
            <InputGroup.Text id="basic-addon1" style={{ width: "12rem" }}>
              Select Warehouse
            </InputGroup.Text>
            <Form.Select
              onChange={(event) => {
                setSelectedWarehouse(event.target.value);
              }}
            >
              <option hidden={true}> select</option>
              {validWarehouseData &&
                validWarehouseData.length &&
                validWarehouseData.map((warehouseOption) => {
                  return (
                    <option value={warehouseOption.code}>
                      {warehouseOption.name}
                    </option>
                  );
                })}
            </Form.Select>
            <Button
              type="primary"
              onClick={async () => {
                await updateWarehouse(
                  {
                    orderId: order.id,
                    locationCode: selectedWarehouse,
                    trackingUrl,
                    trackingId,
                  },
                  setToaster,
                  fetchCustomerData,
                  customerData.id
                );
                handleClose();
              }}
            >
              Update Warehouse
            </Button>
          </InputGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button key="cancel" onClick={() => !isDisabled && handleClose()}>
            Cancel
          </Button>
          <MarkShipped
            parentClose={handleClose}
            currentWarehouse={currentWarehouse}
            selectedWarehouse={selectedWarehouse}
            handleWarehouseClose={handleClose}
            trackingURL={trackingUrl}
            trackingID={trackingId}
            order={order}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default UpdateWarehouseAndMarkShipped;
